/*
 DetailApiManager Module

 */

const DetailApiManager = (function () {
    // ================== PRIVATE OBJECTS ================== //
    const CruiseData = (function () {
        // Constructor
        function CruiseData(cruise_id, target, callback) {
            this.cruise_id = cruise_id
            this.data = undefined;
            this.status = 'loading';
            this.callbacks = [];
            this.addCallback(target, callback);
            this.startload();
        };

        CruiseData.prototype.startload = function() {
            function onDataLoad (data) {
                this.data = data;
                this.loadImg(function () {                
                    for (var i = this.callbacks.length - 1; i >= 0; i--) {
                        this.callbacks[i].callback.apply(this.callbacks[i].target, [this.data]);
                        this.callbacks.pop();
                    };
                }, this);
            };
            _askApiRequest(this.cruise_id, onDataLoad, this);     
        };

        CruiseData.prototype.addCallback = function(target, callback) {
            this.callbacks.push({
                'callback': callback,
                'target': target
            });
        };

        CruiseData.prototype.loadImg = function(callback, target) {
            // Load img :
            var img_charged = 0;
            var expected_img = 2;
            if(this.data.card_skipper_photo_url == '') {
                var expected_img = 1;
            }
            var cruise_photo = new Image();
            var skipper_photo = new Image();
            var self = this;
            var onLoadImg = function () {
                img_charged += 1;
                if (img_charged == expected_img) {
                    self.status = 'ready';
                    callback.apply(target);
                };
            };
            cruise_photo.onload = onLoadImg;
            skipper_photo.onload = onLoadImg;
            cruise_photo.src = this.data.card_photo_url;
            skipper_photo.src = this.data.card_skipper_photo_url;
        };

        return CruiseData;
    })();

    // ================== VARIABLE ================== //
    var _detailListApiUrl;
    var _cruiseData = {}

    var _waitingApiRequest = [];
    var _requestCount = 0;

    // ================== CONSTRUCTOR ================== //
    function DetailApiManager() {
        // Singleton
        if (DetailApiManager.instance) {
            throw new Error('DetailApiManager is a singleton. Use DetailApiManager.instance.');
        }
        // enforces new
        if (!(this instanceof DetailApiManager)) {
            return new DetailApiManager();
        }           
    };

    // ================== PUBLIC METHOD ================== //

    /**
    Reset all cards data.
    Usefull when departure_date parameter changes and all cruises data
    have to be recomputed server-side
    */
    DetailApiManager.prototype.reset = function() {
        _cruiseData = {}
    }

    DetailApiManager.prototype.getCruiseDetail = function(cruise_id, target, callback) {
        if (_cruiseData[cruise_id] == undefined) {
            _cruiseData[cruise_id] = new CruiseData(cruise_id, target, callback);
        } else {
            var curr_status = _cruiseData[cruise_id].status;
            if (curr_status == 'ready')
                callback.apply(target, [_cruiseData[cruise_id].data]);
            else if (curr_status == 'loading')
                _cruiseData[cruise_id].addCallback(target, callback);
        }
    };

    DetailApiManager.prototype.setApiUrl = function(detail_list_api_url) {
        _detailListApiUrl = detail_list_api_url;
    };

    // ================== PRIVATE METHOD ================== //
    function _askApiRequest (cruise_id, callback, target) {
        _requestCount += 1;
        var localCount = _requestCount;

        _waitingApiRequest.push({
            'cruiseId': cruise_id,
            'callback': callback,
            'target': target
        });

        window.setTimeout(function () {
            if (localCount == _requestCount) {
                _requestCount = 0;
                _doRequest();
            }
        }, 100);
    }

    function _doRequest (url, callback, target) {
        var url = _detailListApiUrl + '?id=' + _waitingApiRequest[0].cruiseId;
        for (var i = 1; i < _waitingApiRequest.length; i++) {
            url += '&id=' + _waitingApiRequest[i].cruiseId;
        }
        $.get(url, function (data) {
            var todo;
            for (var i = 0; i < data.length; i++) {
                for (var j = _waitingApiRequest.length - 1; j >= 0; j--) {
                    if (_waitingApiRequest[j].cruiseId == data[i].card_id) {
                        todo = _waitingApiRequest.splice(j,1)[0];
                        todo.callback.apply(todo.target, [data[i]]);
                    }
                }
            }
        });  
    }

    DetailApiManager.instance = new DetailApiManager();

    return DetailApiManager.instance;
})();

export default DetailApiManager


// WEBPACK FOOTER //
// ./search/static/search/js/detailApiManager.js